import React from 'react';
import { ProfileCard } from '../Components/ProfileCard';

export function Introduction() {
	const introData = [
		{ 
			type: 'title', 
			content: 'Hi! My name is Erik Watchorn.' 
		},
		{ 
			type: 'text', 
			content: (
				<>
					I am a <span className="highlight">UI/UX Designer</span> and <span className="highlight">Programmer</span>.
				</>
			)
		},
		{ 
			type: 'text', 
			content: (
				<>
					I have primarily worked on video games most notably <a href="https://www.roblox.com/games/3093229294/Animations-Mocap" target="_blank" rel="noreferrer" className="game-link">Animations: Mocap</a>.
				</>
			)
		},
	];

	return (
		<ProfileCard 
			items={introData} 
			image= "/Images/Headshot.JPEG" 
			activeId="intro"
			alignment="left"
		/>
	);
}